import { Container } from "@material-ui/core";
import ComingSoon from './ComingSoon';

export default function Buschington() {
  return (
    <Container>
      <ComingSoon name="homepage of the yearly tradition at Watkins Glen!!!"/>
    </Container>
  );
}